module.exports = __webpack_public_path__ + "img/51.143b4586.svg";